import React, { useContext, useRef } from "react";

import ChevronRightSharpIcon from "@mui/icons-material/ChevronRightSharp";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../../components/Form";
import { PropHandles } from "../../../../../../components/Generic/ViewJobComponent";
import { MovementContext } from "../../context/MovementContext";
import { MapComponent } from "../Map";
import { SubTitle } from "../SubTitle";
import { ItemDetail } from "./ComponentDetail/ItemDetail";
import { StorageBoxDetail } from "./ComponentDetail/StorageBoxDetail";
import { MoreDetails } from "./MoreDetails";
import {
  ContainerBasicDetails,
  ContainerDetails,
  ContainerNoTasks,
  SeeFullDetailsStyle,
} from "./styles";

const noTasks = require("../../../../../../assets/img/no-tasks.svg");

export const Details = () => {
  const { t: translate } = useTranslation();
  const {
    itemJobSelected: itemJob,
    storageBoxSelected: storageBox,
    mapSelected: map,
    mapCellSelected: mapCell,
    setMapCellSelected: setMapCell,
  } = useContext(MovementContext);

  const sideViewRef = useRef<PropHandles>(null);

  const getTitle = () => {
    if (itemJob) return "itemDetails";

    return "storageBoxDetails";
  };

  const renderNoObjectSelected = (
    subTitleText: string,
    textParagraph: string,
    boxShadow?: boolean
  ) => {
    return (
      <ContainerNoTasks applyBoxShadow={boxShadow}>
        <img src={noTasks} />
        <div>
          <h2>{translate(subTitleText)}</h2>
          <p>{translate(textParagraph)}</p>
        </div>
      </ContainerNoTasks>
    );
  };

  const renderObjectSelected = () => {
    const renderButtonSeeFullDetails = () => {
      return (
        <SeeFullDetailsStyle>
          <Button
            onClick={() => {
              sideViewRef.current?.setOpenSideBar(true);
            }}
            data-cy="button-open-side-bar-details"
          >
            {translate("seeFullDetails")}
            <ChevronRightSharpIcon />
          </Button>
        </SeeFullDetailsStyle>
      );
    };

    const renderMapSelected = () => {
      if (map) {
        return <MapComponent map={map} mapCellSelected={mapCell} setMapCellSelected={setMapCell} />;
      }

      return renderNoObjectSelected(
        "noMapSelected",
        "aLittleMapPreviewWillAppearHereWhenYouSelectTheSectionInTheObjectThatShouldBeMoved"
      );
    };

    if (itemJob || storageBox) {
      return (
        <ContainerBasicDetails>
          <SubTitle text={translate(getTitle())} fontSize={"1.125rem"} />

          {itemJob && <ItemDetail itemJob={itemJob} />}
          {storageBox && <StorageBoxDetail storageBox={storageBox} />}
          {renderButtonSeeFullDetails()}
          {renderMapSelected()}
        </ContainerBasicDetails>
      );
    }

    return renderNoObjectSelected(
      "noObjectSelected",
      "someObjectDetailsWillBeDisplayedWhenYouSelectIt"
    );
  };

  return (
    <ContainerDetails>
      {renderObjectSelected()}
      <MoreDetails
        loading={false}
        sideViewRef={sideViewRef}
        storageBox={storageBox}
        itemJob={itemJob}
        title={getTitle()}
      />
    </ContainerDetails>
  );
};
